import React, { useEffect, useState } from "react";

// JS Files
import ServicesCard from "./ServicesCard";

// Others File
import service1 from "../../imgs/service-1.svg";
import service2 from "../../imgs/service-2.svg";
import service3 from "../../imgs/service-3.svg";

const Services = () => {
  return (
    <>
      <div className="mt-10 md:mt-0 mx-4 md:mx-16 mb-2">
        <p className="header">خدمات ما</p>
        <div className="grid md:grid-cols-3 gap-x-4 md:mt-8 md:mx-4">
          <ServicesCard
            icon={service1}
            type="com-damage"
            header="اعتراض به پرونده خسارت"
            text="معلمان و دانش‌آموزان گرامی، در تمامی رشته‌های بیمه‌ای می‌توانید اعتراض خود را ثبت و پیگیری نمایید."
          />
          <ServicesCard
            icon={service2}
            type="con-damage"
            header="مشاوره خسارت"
            text="ما در کنار شما هستیم تا در صورت هر گونه خسارت، راهنمایی های لازم را جهت دریافت خسارت به شما بدهیم."
          />
          <ServicesCard
            icon={service3}
            type="con-med"
            header="مشاوره پزشکی"
            text="شما فرهنگیان و دانش‌آموزان عزیز می‌توانید کلیه سوالات پزشکی خود را با متخصصان پزشکی رفاپ مطرح کنید."
          />
        </div>
      </div>
    </>
  );
};
export default Services;
